import React, { createContext, useState } from 'react'

export const SnackbarContext = createContext()

export const DEFAULT_SNACKBAR_DURATION = 1500

export const SnackbarProvider = ({ children }) => {
    const [open, setOpen] = useState(false)
    const [severity, setSeverity] = useState('')
    const [message, setMessage] = useState('')
    const [title, setTitle] = useState('')
    const [errors, setErrors] = useState([])
    const [duration, setDuration] = useState(DEFAULT_SNACKBAR_DURATION)

    // options (optional): { errors: string[], duration: ms }
    const displaySnackbar = (newSeverity, newTitle, newMessage, options = {}) => {
        setOpen(true)
        setSeverity(newSeverity)
        setTitle(newTitle)
        setMessage(newMessage)
        setErrors(Array.isArray(options?.errors) ? options.errors : [])
        setDuration(options?.duration || DEFAULT_SNACKBAR_DURATION)
    }

    const closeSnackbar = () => {
        setOpen(false)
    }

    return (
        <SnackbarContext.Provider value={{ open, severity, title, message, errors, duration, displaySnackbar, closeSnackbar }}>
            {children}
        </SnackbarContext.Provider>
    )
}
